import { Entity } from "../entity.service";

export class BlockedCalendarWeek extends Entity {
    type = 'blocked_calendar_weeks';

    id: string;
}
